import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import AppFloatButton from '../UI/AppFloatButton';
import FloatingActions from '../UI/FloatingActions';

const SummerCampLayout = ({onRegisterClick}) => {
  return (
    <div className="summer-camp-wrapper">
      <Header onRegisterClick={onRegisterClick} />
      <main className="summer-main-content">
        <Outlet /> 
      </main>
      <FloatingActions/>
      {/* <AppFloatButton/> */}
      <Footer />
    </div>
  );
};

export default SummerCampLayout;